import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { HouseholdRecordVm } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-household-financial-info',
  standalone: true,
  imports: [ReactiveFormsModule, MatInputModule, MatSelectModule],
  templateUrl: './household-financial-info.component.html',
  styles: [
    `
      .field-hint {
        color: var(--light-neutral-200);
        display: block;
        font-size: var(--font-body-small);
        line-height: 120%;
        padding-top: 0.25rem;
      }
    `
  ]
})
export class HouseholdFinancialInfoComponent {
  @Input() formGroup!: FormGroup;
  @Input() householdData: HouseholdRecordVm;
}
